import dataCreditList from '../../views/fund/data-center/data-credit-list.vue';
var fundDataCenter = [
    {
        name: 'dataCreditList',
        path: 'credit-list',
        component: dataCreditList,
    },
];
export default fundDataCenter;
